<template>
	<div
		id="user-menu"
		class="user-menu"
	>
		<VMenu
			attach="#user-menu"
			:close-on-content-click="false"
			:max-width="currentWidth"
			:min-width="currentWidth"
			nudge-left="250px"
			offset-y
			transition="slide-y-transition"
		>
			<template #activator="{ on, attrs }">
				<AmeliproIconBtn
					btn-label="infos utilisateur"
					:icon="icon"
					icon-bg-color="ap-blue darken-1"
					icon-color="ap-white"
					icon-hover-bg-color="ap-blue darken-2"
					icon-hover-color="ap-white"
					size="2rem"
					v-bind="attrs"
					v-on="on"
				/>
			</template>

			<div class="user-menu-popover ap-white">
				<div class="px-4 pt-3 pb-1">
					<slot>
						<div v-if="userMenuInfos !== undefined && userMenuInfos !== null && userMenuInfos.userMenuDetailsInfos !== undefined && userMenuInfos.userMenuDetailsInfos !== null">
							<UserMenuDetails
								:user-menu-details-infos="userMenuInfos.userMenuDetailsInfos"
							/>
						</div>
					</slot>

					<slot name="complementaryInfo" />

					<p
						v-if="lastConnexion"
						class="mt-6 mb-0 user-menu-last-connexion"
					>
						Dernière connexion : {{ lastConnexion }}
					</p>
				</div>

				<div class="mt-6 d-flex justify-space-between ap-blue lighten-3">
					<AmeliproBtn
						class="text-none user-menu__btn--account"
						hover-underline
						plain
						@click="emitEventAccount()"
					>
						Mon Compte
					</AmeliproBtn>

					<AmeliproBtn
						class="text-none user-menu__btn--logout"
						hover-underline
						plain
						@click="emitEventLogout()"
					>
						Déconnexion
					</AmeliproBtn>
				</div>
			</div>
		</VMenu>
	</div>
</template>

<script setup lang="ts">
	import { PropType, computed } from 'vue';
	import AmeliproBtn from '../AmeliproBtn';
	import AmeliproIconBtn from '../AmeliproIconBtn';
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import UserMenuDetails from '../UserMenuDetails';
	import { UserMenuInfos } from './types';
	import { VMenu } from 'vuetify/lib';

	defineProps({
		icon: {
			type: String,
			default: 'utilisateur',
		},
		lastConnexion: {
			type: String,
			default: undefined,
		},
		userMenuInfos: {
			type: Object as PropType<UserMenuInfos>,
			default: undefined,
		},
	});

	const breakpointHelper = new BreakpointHelper();
	const currentWidth = computed<string>(() => (breakpointHelper.isDesktop() ? '366px' : '280px'));

	const emit = defineEmits(['click:account', 'click:logout']);

	const emitEventAccount = () : void => {
		emit('click:account');
	};

	const emitEventLogout = () : void => {
		emit('click:logout');
	};
</script>

<style lang="scss" scoped>
	.v-btn :deep(.v-btn__content) {
		opacity: 1 !important;
	}

	.user-menu {
		position: relative;
	}

	.user-menu-last-connexion {
		font-size: $font-size-xs;
	}

	.user-menu__btn--account,
	.user-menu__btn--logout {
		padding: 1rem 1.5rem !important;
		border-radius: 0 !important;
	}
</style>
